import { toast } from "react-hot-toast";
import { getPrice } from "../service/getPrice";
import { useCustomNavigation } from "../hooks/useNavigateGAC";

export const useHandleTokenPrice = () => {
  const { handleNavigation } = useCustomNavigation(); // Usa el custom hook

  const handleTokenPrice = async (isStateMora, mmora = "") => {
    if (isStateMora === "1") {
      let message = "Tu plan vacacional presenta mora";
      const moraMessage = mmora || "";

      if (moraMessage) {
        const moraMessageLower = moraMessage.toLowerCase().trim();

        // Detectar solo cuando es por saldo de derechos de afiliación
        const isAffiliationDebt = moraMessageLower.includes("gastos legales");

        if (isAffiliationDebt) {
          message =
            "Tu plan Vacacional Presenta saldo en tus derechos de afiliación complétalos y disfruta los beneficios del portal auto-gestión";
        } else {
          const moraText = moraMessage.slice(38);
          message = `Tu plan vacacional presenta mora ${moraText}`;
        }
      }

      toast.custom(
        (t) => (
          <div className={`go2072408551 ${t.visible ? "show" : "hide"}`}>
            ., <div className="go3958317564">{message}</div>
            <button
              onClick={() => handleNavigation("placeOrder")} // Llama a la función de navegación
              className="btn-payU"
            >
              <span>
                <img
                  src="/icons/card_pay.svg"
                  alt="img mercado de pago"
                  width={38}
                  style={{ marginRight: "10px" }}
                />
                Realiza tú Pago
              </span>
            </button>
          </div>
        ),
        {
          duration: 5000,
          position: "top-center",
        },
      );
    }

    // Lógica para obtener el precio
    try {
      const storedPrice = sessionStorage.getItem("priceURL");

      if (storedPrice) {
        return window.open(storedPrice, "_blank");
      } else {
        const response_price = await getPrice();

        if (response_price?.data?.msg === "Token invalid") {
          sessionStorage.clear();
        }

        if (response_price.length > 0) {
          const priceURL = response_price;
          sessionStorage.setItem("priceURL", priceURL);
          window.open(priceURL, "_blank");
        }
      }
    } catch (error) {
      console.error("Error al obtener el url price:", error);
    }
  };

  return { handleTokenPrice };
};
